import React from 'react';

/** @internal */
export var alternateThinSearchIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "19",
  height: "21",
  viewBox: "0 0 19 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.89981 17.3636C14.3733 17.3636 17.9998 13.7005 17.9998 9.18182C17.9998 4.66312 14.3733 1 9.89981 1C5.4263 1 1.7998 4.66312 1.7998 9.18182C1.7998 13.7005 5.4263 17.3636 9.89981 17.3636Z",
  fill: "none",
  className: "sicl-icon-stroke-color",
  strokeWidth: "0.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.1 15.848L0.590011 20.4035",
  className: "sicl-icon-stroke-color",
  strokeWidth: "0.6",
  strokeLinecap: "round"
}));